<template>
  <div class="input-phone">
    <label class="d-none sr-only" :for="id + '_country'" >Telefon kontaktowy - prefiks</label>
    <ic-select

      :id="id + '_country'"
      class="input-phone__country"
      :values="countries"
      :multiple="false"
      v-model="countryCode"
      track-by="prefix"
      :allowEmpty="false"
    >
      <template slot="singleLabel" slot-scope="{option}">
        <span class="input-phone__label__flag iti-flag" :class="option.iso"></span>
        <span class="input-phone__label__prefix">{{option.prefix}}</span>
      </template>
      <template slot="option" slot-scope="{option}">
        <span class="input-phone__option__flag iti-flag" :class="option.iso"></span>
        <span class="input-phone__option__country">{{option.name}}</span>
        <span class="input-phone__option__prefix">{{option.prefix}}</span>
      </template>
    </ic-select>
    <input
      :id="id"
      type="phone"
      v-model="phoneNumber"
      class="form-control input-phone__phone"
      @input="emmitEvent"
      @keyup="cleanUpInput('phoneNumber')"
      :maxlength="maxlength>0?maxlength:null"
    >
    <span class="counter text-muted" v-if="maxlength > 0">{{charactersLeft}}</span>
  </div>

</template>

<script>
import { getCountries } from "./inputphonecountries";
import IcSelect from "./Select";



export default {
  name: "IcInputPhone",
  props: {
    id: { type: String },
    maxlength: { type: [String,Number], default:30 },
    value: { type: [String, Number] },
    v: { type: Object }
  },
  data() {
    return {
      countryCode: "48",
      phoneNumber: "",
      countries: [{ name: "a", value: "B" }]
    };
  },
  created() {
    getCountries().then(r => {
      this.countries = r;
    });
  },
  computed: {
    phone() {
      return `+${this.countryCode} ${this.phoneNumber}`;
    },
    charactersLeft() {
        var char = this.phoneNumber.length,
            limit = this.maxlength;

        return (char) + " / " + limit + "";
    }    
  },

  watch: {
    value: function(newValue, oldValue) {
      // //console.log("phone", newValue, oldValue, this.phone);
      if (newValue !== this.phone) {
        let p = this.parsePhone(newValue);
        this.countryCode = p.countryCode;
        this.phoneNumber = p.phoneNumber;
      }
    }
  },
  methods: {
    cleanUp(v) {
      return v.replace(/[^0-9\+\s]/g, "").trimLeft();
    },
    cleanUpInput(e) {
      this[e] = this.cleanUp(this[e]);
      // if (this.v) {
      //   setTimeout(() => this.v.$touch(), 200);
      // }
      this.emmitEvent(e);
    },
    parsePhone(v) {
      let phone = v.match(/^(\+[0-9]{0,3}\s)?(.*)$/);
      return {
        countryCode: phone[1] ? phone[1].replace("+", "").trim() : "",
        phoneNumber: phone[2] ? phone[2].trim() : ""
      };
    },
    emmitEvent(event) {
      this.$emit("input", this.phone);
      if (this.v) {
        this.v.$touch();
      }
    }
  },
  components: {
    IcSelect
  }
};
</script>
<style src="../../../../../styles/flag-sprite.css"></style>
<style lang="scss">
.holder {
  position: relative;
}
.counter {
  position: absolute;
margin-top: -34px;
right: 10px;
font-size: 70%;
}
.input-phone__country{
  .multiselect__tags {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
.form-control.input-phone__phone{
  
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  
}
.input-phone {

  position: relative;
  .counter {
  position: absolute;
margin-top: 16px;
right: 10px;
font-size: 70%;
}

  &__phone {
    float: left;
    width: 65% !important;
    border-left: 2px solid white;
  }

  &__country {
    float: left;
    width: 35%;
    li {
      position: relative;
    }
  }

  &__option {
    &__flag {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }
    &__country {
      padding-left: 30px;
    }
    &__prefix {
      margin-left: 5px;
      &:before {
        content: "(+";
      }
      &:after {
        content: ")";
      }
    }
  }

  &__label {
    &__flag {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }
    &__prefix {
      padding-left: 30px;

      &:before {
        content: "(+";
      }
      &:after {
        content: ")";
      }
    }
  }

  .multiselect__content-wrapper {
    min-width: 280px;
  }

  .multiselect__select {
    width: 28px;
    padding: 4px 8px 4px 8px;
  }

  .multiselect__tags {
    padding-right: 28px;
  }
}
</style>
